import { render, staticRenderFns } from "./ShopVideoCategoryTable.vue?vue&type=template&id=557bb9ee&scoped=true&"
import script from "./ShopVideoCategoryTable.vue?vue&type=script&lang=js&"
export * from "./ShopVideoCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopVideoCategoryTable.vue?vue&type=style&index=0&id=557bb9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557bb9ee",
  null
  
)

export default component.exports